import { Injectable } from '@angular/core';

//import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
////import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class InitialAuthGuard implements CanActivate {
  constructor(readonly router: Router) {}
  canActivate(): boolean {
    const userStr = localStorage.getItem('optplanner_user');

    console.log('[InitialAuthGuard] Checking authentication...');
    console.log('[InitialAuthGuard] User:', userStr);

    if (!userStr || userStr === 'null' || userStr === '') {
      // No user stored
      console.log('[InitialAuthGuard] ✗ No user found, redirecting to login');
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }

    try {
      // Try to parse the user to ensure it's valid JSON and has a token
      const user = JSON.parse(userStr);

      if (user && user.token && user.token !== '' && user.token !== 'null') {
        console.log('[InitialAuthGuard] ✓ User authenticated with valid token, allowing access');
        return true;
      } else {
        // User exists but no valid token
        console.log('[InitialAuthGuard] ✗ User has no valid token, redirecting to login');
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login'], { replaceUrl: true });
        return false;
      }
    } catch (e) {
      // Invalid JSON
      console.log('[InitialAuthGuard] ✗ Invalid user JSON:', e, 'redirecting to login');
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
  }
}
